import { SET_IS_PREVIOUS_CUSTOMER } from 'actions';

export function setIsPreviousCustomer(isPreviousCustomer: boolean) {
  return { isPreviousCustomer, type: SET_IS_PREVIOUS_CUSTOMER };
}
